import type { FolderLikeItem } from '@/components/document/sub-components/file-manager/types';

export const sortDirectories = (items: FolderLikeItem[]): FolderLikeItem[] =>
  [...items].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }),
  );
